export const PROFILE_SETTINGS_NET_WORTH_NAME = "profileSettingsNetWorth"
export const PROFILE_SETTINGS_RARITY_COOKIE_NAME = "profileSettingsRarity"
export const PROFILE_SETTINGS_CHAIN_ICON_NAME = "profileSettingsChainIcon"

export function getDefaultProfileSettingsHideWalletWorth() {
  return "false"
}

export function getDefaultProfileSettingsRarity() {
  return "true"
}

export function getDefaultProfileSettingsChainIcon() {
  return "true"
}
